import { useState, useEffect } from 'react';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import MetaData from '../Layouts/MetaData';
import BackdropLoader from '../Layouts/BackdropLoader';

const WalletTable = () => {
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [wallets, setWallets] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        const timeout = setTimeout(async () => {
            setLoading(true);
            try {
                const { data } = await axios.get('/api/v1/admin/wallets', { params: { search } });
                setWallets(data.wallets);
            } catch (error) {
                enqueueSnackbar(error?.response?.data?.message || "Failed to load wallets", { variant: "error" });
            } finally {
                setLoading(false);
            }
        }, 350);
        return () => clearTimeout(timeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const columns = [
        { field: "name", headerName: "Customer", minWidth: 180, flex: 0.4 },
        { field: "email", headerName: "Email", minWidth: 220, flex: 0.5 },
        {
            field: "points",
            headerName: "Points",
            type: "number",
            minWidth: 110,
            flex: 0.25,
            renderCell: (params) => <span className="font-medium text-primary-orange">{params.row.points.toLocaleString()}</span>,
        },
        {
            field: "cash",
            headerName: "1313 Cash",
            type: "number",
            minWidth: 120,
            flex: 0.25,
            renderCell: (params) => <span className="font-medium text-primary-green">HK${params.row.cash.toLocaleString()}</span>,
        },
        {
            field: "totalOrderValue",
            headerName: "Total Order Value",
            type: "number",
            minWidth: 150,
            flex: 0.3,
            renderCell: (params) => <span>HK${params.row.totalOrderValue.toLocaleString()}</span>,
        },
    ];

    const rows = wallets.map((w) => ({ id: w._id, ...w }));

    return (
        <>
            <MetaData title="Admin: 1313 Wallets | 1313 Mart" />

            <h1 className="text-lg font-medium uppercase mb-4">1313 Wallets</h1>

            <div className="bg-white rounded-xl shadow-lg w-full">
                <div className="p-4 border-b">
                    <TextField
                        size="small"
                        label="Search by name or email"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        sx={{ minWidth: 280 }}
                    />
                </div>

                <div style={{ height: 600, width: '100%' }}>
                    {loading ? <BackdropLoader /> : (
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            onRowClick={(params) => navigate(`/admin/wallet/${params.row.id}`)}
                            sx={{ '& .MuiDataGrid-row': { cursor: 'pointer' }, border: 'none' }}
                            disableSelectIconOnClick
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default WalletTable;